import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import { pushToDataLayer } from '../../utils/index'


export const setDataLayerInfo = () => {

    return (dispatch: Dispatch<any>) => {
        networkCall("get", `/dataLayerInfo`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.data && res.data.length) {
                    pushToDataLayer(res.data)
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    console.log(error.response.data)
                }
            });
    }
}
